import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import cn from "classnames"
import moment from "moment"
import { Link } from "react-router-dom"
import { markNotificationAsRead } from "../../../../features/notification/notificationSlice"

const Container = styled.div`
    max-height: 300px;
    width: 350px;
    position: absolute;
    background-color: ${({theme})=> theme.mainBgColor};
    left: -50px;
    top: 60px;
    z-index: 1;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid ${({theme})=> theme.mainBorderColor};
    
    @media only screen and (max-width: 1550px) {
        top: 65px;
        right: 0;
        left: initial;
    }

    .title{
        color: ${({ theme }) => theme.mainTextColor};
        font-weight: var(--font-weight-lg);
        font-size: 16px;
        border-bottom: 2px solid ${({theme})=> theme.mainBorderColor};
        width: 100%;
        text-align: center;
        padding: 10px;
    }
    .notification-list{
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: flex-start;
        width: 100%;
        overflow: auto;
        &::-webkit-scrollbar {
            width: 0;
            width: 6px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.scrollThumbColor};
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
        .notification{
            width: 100%;
            border-bottom: 1px solid ${({theme})=> theme.mainBorderColor};
            padding: 10px;
            display: flex;
            flex-direction: column;
            gap: 5px;
            cursor: pointer;
            &:hover{
                background-color: ${({theme})=> theme.secondaryBgColor};
            }
            .not-title{
                font-weight: var(--font-weight-lg);
            }
            p{
                color: ${({ theme }) => theme.mainTextColor};
                font-weight: var(--font-weight-md);
                font-size: var(--font-size-sm);
            }
            span{
                color: ${({ theme }) => theme.mainTextColor};
                font-weight: var(--font-weight-md);
                font-size: var(--font-size-xs);
                display: flex;
                justify-content: flex-end;
            }
        }
        .notification:last-child{
            border-bottom: none;
        }
        .show-all{
            padding-block: 10px;
            color: var(--color-main);
            font-weight: var(--font-weight-lg);
            font-size: var(--font-size-sm);
        }
    }
    .readed{
        p{
            color: ${({ theme }) => theme.secondaryTextColor} !important;
        }
        span{
            color: ${({ theme }) => theme.secondaryTextColor} !important;
        }
    }
`

const TopbarNotification = () => {

    const dispatch = useDispatch()
    const {notificationList} = useSelector((state)=> state.notification)
    
  return (
    <Container>
        <div className="title">Bildirimler</div>
        <div className="notification-list">
            {notificationList?.length > 0 ? 
            <>
                {notificationList.map((item) => {
                    const now = moment();
                    const notificationTime = moment(item.createOn);

                    let displayTime;
                    if (now.isSame(notificationTime, "day")) {
                        const hoursAgo = now.diff(notificationTime, "hours");
                        displayTime = `${hoursAgo} saat önce`;
                    } else if (now.subtract(1, "days").isSame(notificationTime, "day")) {
                        displayTime = `Dün ${notificationTime.format("HH:mm")}`;
                    } else {
                        displayTime = notificationTime.format("DD.MM.YYYY HH:mm");
                    }

                    return (
                        <Link onClick={() => dispatch(markNotificationAsRead({id: item.id}))} to={item.route} key={item.id} className={cn("notification", item.isRead ? "readed" : "")}>
                            <p className="not-title">{item.title}</p>
                            <p className="text">{item.text}</p>
                            <span>{displayTime}</span>
                        </Link>
                    );
                }).slice(0, 5)}
                {
                    notificationList?.length > 5 && <Link to={"/bildirimler"} className="show-all">Tümünü Gör ({notificationList?.length})</Link>
                }
            </>
             : (
                <div className="notification">
                    <p>Yeni bildirim yok.</p>
                </div>
            )}
        </div>
    </Container>
  )
}

export default TopbarNotification